module.exports = __webpack_public_path__ + "img/signal-bars-good.aa39bbba.svg";